import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProcurementInventory from '../../components/ProcurementInventory';
import { Route } from 'react-router-dom';
import { PROCUREMENTINVENTORY } from '../../routes';

const ProcurementInventoryRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PROCUREMENTINVENTORY}
				render={props => <ProcurementInventory {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProcurementInventoryRoute;
